
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.77197 8.55768C6.1346 8.19505 6.72254 8.19505 7.08517 8.55768L12 13.4725L16.9148 8.55768C17.2775 8.19505 17.8654 8.19505 18.228 8.55768C18.5907 8.92031 18.5907 9.50825 18.228 9.87088L12.6566 15.4423C12.294 15.8049 11.706 15.8049 11.3434 15.4423L5.77197 9.87088C5.40934 9.50825 5.40934 8.92031 5.77197 8.55768Z","fill":"#16171F"}})])
          )
        }
      }
    